<mat-dialog-content class="text-center">
    <app-loader class="inline"></app-loader>
    <h2>{{ 'Nous devons vérifier vos informations de paiement.' | transloco }}</h2>
    <p>{{ 'Vous allez être redirigé automatiquement vers notre prestataire de paiement.' | transloco }}</p>
</mat-dialog-content>
